import { ServiceTokens } from "$src/domain/ServiceTokens";
import { CreateProjectData } from "$src/domain/projects/CreateProjectData";
import type { IProjectRepository } from "$src/domain/projects/IProjectRepository";
import { ProjectIdentifier } from "$src/domain/projects/ProjectIdentifier";
import { inject, injectable } from "tsyringe";

@injectable()
export class CreateProject {
    
    constructor(@inject(ServiceTokens.ProjectService) private projectRepository: IProjectRepository) {}

    async execute(groupStoreId: number, data: CreateProjectData): Promise<ProjectIdentifier> {

        var identifier = await this.projectRepository.createProject(groupStoreId, data);

        return identifier;
    }
}

export const CreateProjectToken = Symbol('CreateProjectToken');